import { Button } from "@mui/material";
import SvgIcons from "../svgIcons";
import { FC } from "react";

export type TitleBarProps = {
  onClick?: Function;
  disabled?: boolean;
};

export const EditButton: FC<TitleBarProps> = ({ onClick, disabled }) => {
  return (
    <Button
      variant="outlined"
      size="small"
      id={`edit-button`}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      startIcon={<SvgIcons.EditButtonIcon />} // Add icon here
      sx={{ mr: 2 }}
    >
      Edit
    </Button>
  );
};
